import React, { useState } from 'react'
import Header from 'portal/layouts/BasicLayout/Header'
import Banner from 'portal/views/ExteriorFacade/Banner'
import ItemShow from 'portal/views/ExteriorFacade/ItemShow'
import MyApplication from 'portal/views/ExteriorFacade/MyApplication'
import ResearchProjects from 'portal/views/ExteriorFacade/ResearchProjects'
import ExploreTopics from 'portal/views/ExteriorFacade/ResearchIdeas'
import EfficiencyTools from 'portal/views/ExteriorFacade/ResearchTools'
import LearningPromotion from 'portal/views/ExteriorFacade/ResearchTraining'
import Footer from 'portal/layouts/BasicLayout/Footer/Footer'
import { WheelEvent } from 'react/index'


export default function ExteriorFacade() {
  const [visible, setVisible] = useState(true)
  function handleScroll(e:WheelEvent<HTMLDivElement>) {
    if (e.deltaY) {
      if(e.deltaY > 0) {
        setVisible(false)
      }
      if(e.deltaY < 0) {
        setVisible(true)
      }
    }
  }
  function showHeader() {
    if(visible) {
      return (
        <Header />
      )
    }
    return (<></>)
  }
  return (
    <div style={{ background: '#F5F6F6' }}>
      {showHeader()}
      <div onWheel={handleScroll}>
        <Banner />
        <ItemShow />
        <MyApplication />
        <ResearchProjects />
        <ExploreTopics />
        <EfficiencyTools />
        <LearningPromotion />
        <Footer />
      </div>
    </div>
  )
}
